exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-68b37ad3]{margin:0 auto;width:150px;text-align:center;margin-bottom:10px}.spinner>div[data-v-68b37ad3]{width:12px;height:12px;border-radius:100%;display:inline-block;animation:bouncedelay-data-v-68b37ad3 1.4s infinite ease-in-out;animation-fill-mode:both}.spinner .bounce1[data-v-68b37ad3]{animation-delay:-.32s;background-color:#b39479}.spinner .bounce2[data-v-68b37ad3]{animation-delay:-.16s;background-color:#b39479}.spinner .bounce3[data-v-68b37ad3]{background-color:#b39479}@keyframes bouncedelay-data-v-68b37ad3{0%,80%,to{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68b37ad3","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/agent/go-pay.vue
// module id = 475
// module chunks = 1